export function extractVersionNumberFromBackendJs(backendJs: string): number {
  const latestVersionStr = backendJs.match(/\d+/)![0];
  return +latestVersionStr;
}

let _currentFrontendVersion: number | null = null;

export function getCurrentFrontendVersion(): number | null {
  return _currentFrontendVersion;
}

export function setCurrentFrontendVersion(version: number): void {
  _currentFrontendVersion = version;
}

export async function fetchFrontendVersion(): Promise<number> {
  const response = await fetch('../Content/orna-version.js');
  const text = await response.text();
  const versionStr = text.match(/\d+/)![0];
  return +versionStr;
}

export async function fetchBackendVersion(): Promise<number> {
  const response = await fetch('https://orna.kerkton.com/Content/orna-backend-version.js');
  if (!response.ok) throw new Error('Failed to fetch backend version');
  const text = await response.text();
  return extractVersionNumberFromBackendJs(text);
}

export async function isNewFrontendVersionAvailable(): Promise<boolean> {
  const latest = await fetchFrontendVersion();
  const current = getCurrentFrontendVersion();
  if (current && current > 0 && latest > 0 && current !== latest) {
    return true;
  }
  return false;
}
